import { render } from "./customers-modal.vue?vue&type=template&id=ef6e6d52"
import script from "./customers-modal.vue?vue&type=script&lang=js"
export * from "./customers-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__